import { create } from 'zustand';
import { createJSONStorage, persist, subscribeWithSelector } from 'zustand/middleware';
import Config from '@annunciate/core/dist/utils/config';
import { storage as mmkv } from './mmkv-store';
import { PlaybackState } from '../enums';
import { INITIAL_PLAYER_INDEX } from '../utils';
const RESUMING_PLAYER_INDEX = Config?.APP_RESUMING_PLAYER_INDEX
    ? parseInt(Config.APP_RESUMING_PLAYER_INDEX, 10)
    : 0;
const storage = {
    getItem: (key) => mmkv.getString(key) || null,
    setItem: (key, value) => mmkv.set(key, value),
    removeItem: (key) => mmkv.delete(key),
};
export const usePlaybackStateStore = create()(subscribeWithSelector(persist((set, get) => ({
    restartAttempts: 0,
    content: undefined,
    isPlaying: false,
    playerIndex: INITIAL_PLAYER_INDEX,
    setPlayerIndex: (index) => set(() => ({
        playerIndex: index,
    })),
    sleepTime: undefined,
    setSleepTime: (time) => set(() => ({
        sleepTime: time,
    })),
    lastContentEvent: undefined,
    setLastContentEvent: (event) => set(() => ({
        lastContentEvent: event,
    })),
    playtimeInfo: undefined,
    setPlaytimeInfo: (info) => set(() => ({
        playtimeInfo: info,
    })),
    states: {},
    setState: (id, newState) => set((state) => ({
        states: {
            ...state.states,
            [id.toString()]: newState,
        },
    })),
    getState: (id) => {
        const states = get().states;
        if (states[id.toString()]) {
            return states[id.toString()];
        }
        else {
            return PlaybackState.NONE;
        }
    },
    getInitialPlayerIndex: () => {
        const content = get().content;
        if (!content)
            return INITIAL_PLAYER_INDEX;
        const state = get().getState(content.id);
        if (state === PlaybackState.NONE) {
            return INITIAL_PLAYER_INDEX;
        }
        else {
            return RESUMING_PLAYER_INDEX;
        }
    },
}), {
    name: "playback-state-storage",
    storage: createJSONStorage(() => storage),
    partialize: (state) => {
        let content = state.content;
        const states = {};
        if (content) {
            const contentId = content.id.toString() || "";
            if (state.states[contentId] === PlaybackState.NONE) {
                content = null;
            }
            else {
                states[contentId] = PlaybackState.STOPPED;
            }
        }
        return {
            content,
            states,
        };
    },
})));
//# sourceMappingURL=usePlaybackStateStore.js.map